import React, { useContext, useEffect, useState, useRef } from 'react'
import axios from 'axios'
import { has, uniqueId, isEmpty, get, map, keys, difference } from 'lodash'
import { useClickAway } from 'react-use'
import { BookInfo, Errors, MenuContext, UserInfo } from '../../contexts/menuContext'
import { getPage } from '../../api/getPage'

const Controls = ({ navigation, navigationList, materials }) => {
  const [book, setBook, page, , , , overlay, setOverlay, csrfToken] = useContext(BookInfo)
  const category = navigation.find((item) => {
    if (has(item, 'children')) {
      return JSON.stringify(item.children).search(`"${page}"`) >= 0
    }
    return false
  })
  const [user] = useContext(UserInfo)
  const [menuStatus, changeMenuStatus, rightSidebar, changeRightSidebar, userClosedMenu, setUserClosedMenu] = useContext(MenuContext)
  const [bookmark, setBookmark] = useState(false)
  const [bookmarkItems, setBookmarkItems] = useState(get(user, `bookmarks[${page}]`, []))
  const [whatNew, setWhatNew] = useState(get(book, 'whatNew', true))
  const [content, setContent] = useState({})
  const [value, setValue] = useState('')
  const [, setError] = useContext(Errors)
  const [inputState, setImputstate] = useState(true);
  const [collections, setCollections] = useState(user.collections)
  const ref = useRef(null)
  useClickAway(ref, () => {
    setOverlay(!bookmark)
    setBookmark(!bookmark)
  })

  useEffect(() => {
    setBookmarkItems(get(user, `bookmarks[${page}]`, []))
  }, [page, user])
  useEffect(() => {
    if (window.Drupal && has(window, 'Drupal.attachBehaviors')) {
      window.Drupal.attachBehaviors()
    }
    if (!isEmpty(page)) {
      getPage(page, book).then((data) => {
        setContent(data)
        window.Drupal.attachBehaviors()
      })
    }
  }, [page, book, rightSidebar])
  // TODO: Find a better way to reduce duplicated function in MobileMenu.js
  const renderHeaderTextPrint = () => {
    let context = 'nclc'
    if (window.Drupal && window.Drupal.getNclcCurrentContext()) {
      context = window.Drupal.getNclcCurrentContext()
    }

    let logo = '<div class="logo"><img src="/themes/custom/nclc/images/logo-print.png" /></div>'
    let intro = '<div class="intro">Published on NCLC Digital Library (https://library.nclc.org/). Read more and subscribe to this and other treatises at NCLC Digital Library (https://library.nclc.org/)</div>'

    switch (context) {
      case 'nhlp':
        logo = '<div class="logo"><img src="/themes/custom/nclc/images/nhlp-logo-print.jpg" /></div>'
        break

      case 'nclej':
        logo = '<div class="logo"><img src="/themes/custom/nclc/images/nclej-logo-print.png" /></div>'
        break
    }

    // There should be cleaner way or maybe new Date().toLocaleDateString() is enough
    const d = new Date();
    const monthNames = ["January", "February", "March", "April", "May", "June",
      "July", "August", "September", "October", "November", "December"
    ];
    const downloadDate = '<div class="download-date"><strong>Date downloaded:</strong> '+ monthNames[d.getMonth()] + ' ' + d.getDate() + ', '+ d.getFullYear()+ ' ' + d.getHours()+ ':'+ d.getMinutes() +'</div>'
    const bookTitle = '<h2 class="book-title">' + document.querySelector('.book-control-header h1').innerHTML + '</h2>'
    const headerTextPrint = '<div class="header-print-content">'+ logo + intro + downloadDate + bookTitle +'</div>'
    return headerTextPrint
  }

  const submitCollection = () => {
    setImputstate(false);
    axios.post('/bookreader/bookmark', {
      subsection_id: page,
      collection_name: value
    }, {
      headers: {
        'X-CSRF-Token': csrfToken
      }
    }).then((response) => {
      setImputstate(true)
      setValue('')
      const newColl = get(response, 'data.data[0].collections')

      setBookmarkItems([...bookmarkItems, difference(keys(newColl), keys(collections))[0]])
      setCollections(get(response, 'data.data[0].collections'))
      const err = get(response, 'data.data[0].errors')
      if (err) {
        setError(err[0])
      }
    })
  }
  useEffect(() => {
    const close = (e) => {
      if (e.keyCode === 27) {
        setOverlay(false)
        setBookmark(false)
      }
    }
    window.addEventListener('keydown', close)
    return () => window.removeEventListener('keydown', close)
  }, [setOverlay])
  return (
    <div className="control-wrapper">
      <div className={`overlay status-${overlay}`} />
      <div className="view-toggle">
        <button
          type="button"
          onClick={() => {
            changeMenuStatus(!menuStatus)
            changeRightSidebar(false)
            setUserClosedMenu(!userClosedMenu)
          }
          }
          className="btn btn-primary"
        >
          <svg
            width="1em"
            height="1em"
            viewBox="0 0 16 16"
            className="bi bi-caret-left-fill"
            fill="currentColor"
          >
            <path
              d="M3.86 8.753l5.482 4.796c.646.566 1.658.106 1.658-.753V3.204a1 1 0 0 0-1.659-.753l-5.48 4.796a1 1 0 0 0 0 1.506z"
            />
          </svg>
        </button>
      </div>
      {!materials && <div className="control-group">
        <a
          className="what-new"
          href="#see"
          onClick={() => {
            setWhatNew(!whatNew)
            setBook({ ...book, whatNew: !whatNew })
            return false
          }}
        >
          {/* eslint-disable-next-line react/no-unescaped-entities */}
          <svg xmlns="http://www.w3.org/2000/svg" id="Outlined" viewBox="0 0 32 32" fill="currentColor">
            <title/>
            <g id="Fill">
              <polygon points="28.71 4.71 27.29 3.29 16 14.59 4.71 3.29 3.29 4.71 14.59 16 3.29 27.29 4.71 28.71 16 17.41 27.29 28.71 28.71 27.29 17.41 16 28.71 4.71"/>
            </g>
          </svg>
          see what's new
        </a>

        <div className="control-group--icons">
          <a
            href="#bookmark"
            className={`control-bookmark ${!isEmpty(bookmarkItems) && 'marked'} ${(get(user, 'id') && isFinite(String(page))) ? 'logged' : 'anonymous'}`}
            onClick={() => {
              if (get(user, 'id') && isFinite(String(page))) {
                setOverlay(!bookmark)
                setBookmark(!bookmark)
              }
            }}
          >
            <svg
              width="1.5rem"
              height="1.5rem"
              fill="currentColor"
              viewBox="-64 0 512 512"
            >
              <path xmlns="http://www.w3.org/2000/svg" d="m324.070312 0h-264.058593c-33.089844 0-60.011719 26.882812-60.011719 59.929688v452.070312l192.066406-125.066406 192.015625 124.4375v-451.441406c0-33.046876-26.921875-59.929688-60.011719-59.929688zm20.003907 437.765625-152.058594-98.542969-152.007813 98.980469v-378.273437c0-10.984376 8.972657-19.921876 20.003907-19.921876h264.058593c11.027344 0 20.003907 8.9375 20.003907 19.921876zm-132.027344-267.730469h70.015625v40.011719h-70.015625v70.011719h-40.011719v-70.011719h-70.011718v-40.011719h70.011718v-70.011718h40.011719zm0 0"/>
            </svg>
          </a>
          <a
            className={`${get(user, 'id') ? 'logged' : 'anonymous'}`}
            href="#download"
            onClick={(e) => {
              e.preventDefault();
              const prtContent = document.querySelector(`.page[data-id="${page}"]`)
              const WinPrint = window.open('', '', 'left=0,top=0,width=800,height=900,toolbar=0,scrollbars=0,status=0')

              WinPrint.document.write('<link rel="stylesheet" type="text/css" href="/modules/custom/nclc_book/css/main.chunk.css">')

              const headerTextPrint = renderHeaderTextPrint()

              WinPrint.document.write(headerTextPrint + prtContent.innerHTML)
              WinPrint.document.close()
              WinPrint.setTimeout(() => {
                WinPrint.focus()
                WinPrint.print()
                WinPrint.close()
              }, 1000)
            }}
          >
            <svg
              width="1.5rem"
              height="1.5rem"
              fill="currentColor"
              viewBox="0 0 477.867 477.867"
            >
              <g>
                <path d="M409.6,153.6h-85.333c-9.426,0-17.067,7.641-17.067,17.067s7.641,17.067,17.067,17.067H409.6    c9.426,0,17.067,7.641,17.067,17.067v221.867c0,9.426-7.641,17.067-17.067,17.067H68.267c-9.426,0-17.067-7.641-17.067-17.067    V204.8c0-9.426,7.641-17.067,17.067-17.067H153.6c9.426,0,17.067-7.641,17.067-17.067S163.026,153.6,153.6,153.6H68.267    c-28.277,0-51.2,22.923-51.2,51.2v221.867c0,28.277,22.923,51.2,51.2,51.2H409.6c28.277,0,51.2-22.923,51.2-51.2V204.8    C460.8,176.523,437.877,153.6,409.6,153.6z"/>
                <path d="M335.947,243.934c-6.614-6.387-17.099-6.387-23.712,0L256,300.134V17.067C256,7.641,248.359,0,238.933,0    s-17.067,7.641-17.067,17.067v283.068l-56.201-56.201c-6.78-6.548-17.584-6.361-24.132,0.419c-6.388,6.614-6.388,17.1,0,23.713    l85.333,85.333c6.657,6.673,17.463,6.687,24.136,0.03c0.01-0.01,0.02-0.02,0.031-0.03l85.333-85.333    C342.915,261.286,342.727,250.482,335.947,243.934z"/>
              </g>
            </svg>
          </a>
          <span
            className={`${get(user, 'id') ? 'logged' : 'anonymous'}`}
            dangerouslySetInnerHTML={{ __html: get(user, 'id') ? get(content, 'actionbar.share_by_email') : '<a class="share-by-email">Share by email</a>' }}
          />
          {bookmark && <div className="bookmarks-popup" ref={ref}>
            <div className="bookmarks-popup--inner">
              <button
                type="button"
                className={`btn btn-light close ${get(user, 'id') ? 'logged' : 'anonymous'}`}
                onClick={() => {
                  setOverlay(!bookmark)
                  setBookmark(!bookmark)
                }}
              >
                <span aria-hidden="true">&times;</span>
              </button>
              <h4>
                Add a bookmark
              </h4>
              <div className="bookmarks-popup--description">
                Add bookmark to existing collection or simply create a new collection by giving it a name.
              </div>
              {keys(collections).length > 0 &&
                <div className="bookmarks-popup--groups-wrap">
                  <div className="bookmarks-popup--label">
                    Add bookmark to:
                  </div>
                  <div className="bookmarks-popup--groups">
                    {map(collections, (data, id) => {
                      return <div
                        onClick={() => {
                          axios.post('/bookreader/bookmark', {
                            subsection_id: page,
                            collection_id: id
                          }, {
                            headers: {
                              'X-CSRF-Token': csrfToken
                            }
                          }).then((res) => {
                            const err = get(res, 'data.data[0].errors')
                            if (!isEmpty(err)) {
                              setError(err[0])
                            } else {
                              bookmarkItems.includes(id) ?
                                user.bookmarks[page] = bookmarkItems.filter((i) => i !== id) :
                                user.bookmarks[page] = [...bookmarkItems, id] // add item
                              setBookmarkItems(get(user, `bookmarks[${page}]`, []))
                            }
                          })
                        }}
                        key={id}
                        className={`bookmarks-popup--group-checkbox ${bookmarkItems && bookmarkItems.includes(id) && 'active'}`}
                      >
                        <svg xmlns="http://www.w3.org/2000/svg" id="Outlined" viewBox="0 0 32 32" fill="currentColor"><title /><g id="Fill"><polygon points="28.71 4.71 27.29 3.29 16 14.59 4.71 3.29 3.29 4.71 14.59 16 3.29 27.29 4.71 28.71 16 17.41 27.29 28.71 28.71 27.29 17.41 16 28.71 4.71" /></g></svg>
                        {data.title}
                      </div>
                    })}
                  </div>
                </div>
              }
              {keys(collections).length < 10 ?
                <div className="bookmarks-popup--new-group-wrap">
                  <div className="bookmarks-popup--label">
                    Or create a new collection:
                  </div>
                  <input
                    placeholder="New Collection's Name"
                    type="text"
                    onChange={(event) => {
                      setValue(event.target.value)
                    }}
                    disabled={!inputState}
                    onKeyPress={(event)=> {
                      if (event.key === 'Enter') {
                        submitCollection()
                      }
                    }}
                    value={value}
                  />
                  {value && <button
                    disabled={!inputState}
                    className="btn-link"
                    onClick={() => submitCollection()}
                  ><span>Add</span>
                            </button>}

                </div> : <div className="bookmarks-popup--new-group-wrap" >
                  <div className="bookmarks-popup--label">
                    Or create a new collection:
                  </div>
                  You have created the maximum number of allowed collections.
                </div>}
            </div>
          </div>}
        </div>
      </div>}

      <div className="book-control-header">
        <h1>{book.title}</h1>
        {(has(category, 'value.title') || materials) &&
        <h2>{!materials ? category.value.title : 'Companion Materials'}</h2>}
      </div>
      { !isEmpty(navigationList) &&
      <div className="book-control-nav-header">
        { !materials && navigationList.map((item) => {
          const current_page_title = document.querySelector('#p_'+ page +' h1')
          if (current_page_title && (current_page_title.innerHTML != item.title)) {
            return <div key={`n_${uniqueId()}`}>{item.title}</div>
          }
        })}
      </div>}

    </div>
  )
}

export default Controls
